// The browser's side of better-auth (ADR 0009): the sign-in pages call better-auth's
// endpoints at `/api/auth/*` through this client. `oauthProviderClient` adds the signed
// authorization request in the page's query string to each call, so signing in or
// consenting on a page an MCP client sent the browser to carries on with that client's
// authorization; better-auth answers with where to go next, and the client goes there.
import { createAuthClient } from "better-auth/react";
import { usernameClient } from "better-auth/client/plugins";
import { oauthProviderClient } from "@better-auth/oauth-provider/client";

export const authClient = createAuthClient({
  basePath: "/api/auth",
  plugins: [usernameClient(), oauthProviderClient()],
  // The global `fetch` at the time of each call, rather than the one there was when this
  // module loaded, so a component test can stand in for better-auth at the network.
  fetchOptions: { customFetchImpl: (input, init) => fetch(input, init) },
});
